module.exports = __webpack_public_path__ + "assets/img/组 94.8c3ddf33.svg";